module.exports = __webpack_public_path__ + "media/images/athletes/1360-d6518125105b910e169e243358427a78.png";